module.exports = require('./helpers/bundle-url').getBundleURL('i2AHq') + "logo-dark.ba5147f0.svg";